/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { PIQuestionData, PIReport, PIReportResponse, PISummary } from '../../models/pi/pi.model';
import { ObservableResult } from '../../store';

/** Injection token for the data service, used by angular to decide whether to inject Mock or API service at runtime. */
export const PI_DATA_SERVICE = new InjectionToken<PIDataService>('[personality indicator] PIDataService');

export interface PIDataService {
  loadPISummary(resourceUid: string): ObservableResult<PISummary>;

  /**
   * `languageCode` is the language the learner reads the indicator in. Omit it to keep the
   * interceptor's default, which follows the language the app is displayed in.
   */
  getPIQuestion(resourceUid: string, version: number, languageCode?: string): ObservableResult<PIQuestionData>;

  addPIQuestionAnswer(
    resourceUid: string,
    version: number,
    request: PIQuestionData,
    languageCode?: string,
  ): ObservableResult<PIQuestionData>;

  getPIReports(resourceUid: string, languageCode?: string): ObservableResult<PIReportResponse>;

  getPIReportByVersion(resourceUid: string, version: number, languageCode?: string): ObservableResult<PIReport>;
}
